<template>
<div>
  <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else class="invoice-create-page">
    <!--  credit form component -->
    <RetainerInvoicePaymentForm
      :submitted="submitted"
      :duplicatecode="duplicatecode"
      page="create"
      :lists="lists"
      v-on:onSubmit="onSubmit($event)"
      :status_message="status_message"
    >
      <!-- footer block -->
    </RetainerInvoicePaymentForm>
  </div>
</div>
</template>

<script>
import RetainerInvoicePaymentForm from "@/components/Form/PaymentsReceived/PaymentForm"; // payment form for update payment record
import RecordNotFound from "@/pages/Error/RecordNotFound";
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling date in format

export default {
  name: "RetainerInvoicePayment",
  mixins: [notificationMixin, formatDate], // call the glbal mixin fucntion
  components: {
    RetainerInvoicePaymentForm,
    RecordNotFound
  },
  data() {
    return {
      lists: "",
      submitted: false,
      duplicatecode: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("retainer/updatePayment", {
          id: this.$route.params.id,
          field: {
            type: "retainer",
            header_details: data
          }
        })
        .then(() => {
          var message;
          if (this.status_code == 200) {
            //  show if invoice successfully created
            message = "Customer Deposit payment has been created successfully!";
            this.$router.push({
              name: "RetainerInvoiceView",
              params:{
                id:this.$route.params.id
              }
            });
            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: message,
              type: "success",
              showCloseButton: true
            });
          } else {
            this.duplicatecode = true;
            this.submitted = false;
          }
        })
        .catch(() => {});
    }
  },
  updated: function() {},
  created() {
    if (Object.entries(this.list).length == 0) {
      this.$router.go(-2);
      return;
    }
    this.lists = {
      cus_id: this.list.header_details.cus_name,
      is_export: this.list.header_details.is_export,
      cus_currency: this.list.header_details.cus_currency,
      unit_currency_value: this.list.header_details.unit_currency_value,
      pymnt_date: this.formatDate(new Date()),
      bank_charges: parseFloat(0).toFixed(2),
      pymnt_mthd: "1",
      deposit_mthd: "",
      tns_no: "",
      due_amount: parseFloat(this.list.header_details.due_amount).toFixed(2),
      paid_amount: parseFloat(this.list.header_details.due_amount).toFixed(2),
      list_no: this.list.header_details.retainer_no,
      disabled: true
    };
    this.$store.state.retainer.status_code=''
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch(
        "payment/fetchPaymentmethod",
        JSON.stringify({
          type: "payment_received"
        })
      )
      .then(() => {
        next();
      });
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: state => state.retainer.list,
      code: state => state.retainer.code,
      status_code: state => state.retainer.status_code, 
      status_message: state => state.retainer.status_message, 
      status_type: state => state.retainer.status_type 
    })
  }
};
</script> 

<style>
</style>
